package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.Serializable

@Serializable
class DataModel(

)